import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationService } from '../../../../services/notification.service';
import { LooseObject } from '../../../../objects/loose-object';
import { get } from 'lodash-es';

@Component({
  selector: 'contract-profitability-analysis-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: [
    './dialog.component.scss',
  ],
})
export class ContractProfitabilityAnalysisDialogComponent {

  isLoading: boolean = false;

  arJobTypeAnalysis: JobTypeAnalysis[] = [];

  objProfitabilityCost: ProfitabilityCost;

  objProfitabilityTotal: ProfitabilityTotal;

  constructor(
    @Inject(MAT_DIALOG_DATA) protected readonly data: LooseObject,
    protected matDialogRef: MatDialogRef<ContractProfitabilityAnalysisDialogComponent>,
    protected notificationService: NotificationService
  ) {
  }

  ngOnInit(): void {
    if (get(this.data, 'job_type_analysis')) {
      this.data.job_type_analysis.forEach( objJobTypeAnalysis =>
        this.arJobTypeAnalysis.push(new JobTypeAnalysis(objJobTypeAnalysis))
      );
    }
    this.objProfitabilityCost = new ProfitabilityCost(this.data)
    this.objProfitabilityTotal = new ProfitabilityTotal(this.data);
  }

  onCancelDialog(response: LooseObject[] = []): void {
    this.matDialogRef.close(response);
  }
}

export class JobTypeAnalysis {
  id: string;
  text: string;
  billable: ProfitabilityDetails;
  non_billable: ProfitabilityDetails;
  constructor(properties: LooseObject) {
    this.id = properties.id;
    this.text = properties.text;
    this.billable = new ProfitabilityDetails(get(properties, 'billable', {}));
    this.non_billable = new ProfitabilityDetails(get(properties, 'non_billable', {}));
  }
}

export class ProfitabilityDetails {
  total_job_count: number;
  total_revenue: number;
  total_labour_cost: number;
  total_material_cost: number;
  total_profit: number;
  total_margin: number;
  constructor(properties: LooseObject) {
    this.total_job_count = get(properties, 'total_job_count', 0);
    this.total_revenue = get(properties, 'total_revenue', 0);
    this.total_labour_cost = get(properties, 'total_labour_cost', 0);
    this.total_material_cost = get(properties, 'total_material_cost', 0);
    this.total_profit = get(properties, 'total_profit', 0);
    this.total_margin = get(properties, 'total_margin', 0);
  }
}

export class ProfitabilityCost {
  labour_actual_duration: number;
  labour_actual_cost: number;
  materials_actual_cost: number;
  constructor(properties: LooseObject) {
    this.labour_actual_duration = get(properties, 'labour_actual_duration', 0);
    this.labour_actual_cost = get(properties, 'labour_actual_cost', 0);
    this.materials_actual_cost = get(properties, 'materials_actual_cost', 0);
  }
}

export class ProfitabilityTotal {
  service_profitability: number;
  minor_works_profitability: number;
  profitability_revenue: number;
  profitability_cost: number;
  profitability_profit: number;
  profitability_margin: number;
  constructor(properties: LooseObject) {
    this.service_profitability = get(properties, 'service_profitability', 0);
    this.minor_works_profitability = get(properties, 'minor_works_profitability', 0);
    this.profitability_revenue = get(properties, 'profitability_revenue', 0);
    this.profitability_cost = get(properties, 'profitability_cost', 0);
    this.profitability_profit = get(properties, 'profitability_profit', 0);
    this.profitability_margin = get(properties, 'profitability_margin', 0);
  }
}